"use client";

import { useEffect, useRef, useState } from "react"; // GLOBAL CUSTOM COMPONENTS
import SalifyFallback from "src/lib/components/salify-fallback/default";

import SideNavbar from "./side-nav-bar"; // CUSTOM DATA MODEL
import { SidebarContainer } from "./styles";

// ==============================================================
const Sidebar = ({ children }) => {
  const pageContentRef = useRef();
  const [sidebarHeight, setSidebarHeight] = useState(0);
  useEffect(() => setSidebarHeight(pageContentRef.current.offsetHeight), []);
  return (
    <SidebarContainer>
      <div className="sidenav">
        <SalifyFallback.Value
          path="output:categories.data"
          default={[]}
          render={(items) => {
            return (
              <SideNavbar
                lineStyle="none"
                navList={items || []}
                sidebarStyle="style2"
                sidebarHeight={sidebarHeight || "85vh"}
              />
            );
          }}
        />
      </div>

      <div className="pageContent" ref={pageContentRef}>
        {children}
      </div>
    </SidebarContainer>
  );
};

export default Sidebar;
